import axios from "axios";
import config from "../Config/config";

export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

export const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "link",
  "image",
  "video",
];

export const checkDocsPermission = async () => {
  const userId = localStorage.getItem("userId");
  if (!userId) {
    return { allowed: false, error: "User ID not found." };
  }

  try {
    const response = await axios.get(
      `${config.API_BASE_URL}/get-user-details?userId=${userId}`
    );
    const { permissions } = response.data;
    const allowed =
      Boolean(permissions?.documents) || localStorage.getItem("admin") === "true";

    return {
      allowed,
      error: allowed ? null : "You do not have permission to manage documents.",
    };
  } catch (err) {
    return {
      allowed: false,
      error: err.response?.data?.error || err.message,
    };
  }
};

export const buildSectionTree = (flatSections) => {
  const map = {};
  const roots = [];

  (flatSections || []).forEach((section) => {
    map[section.id] = { ...section, subsections: [] };
  });

  (flatSections || []).forEach((section) => {
    const current = map[section.id];
    if (section.parentId && map[section.parentId]) {
      map[section.parentId].subsections.push(current);
      return;
    }
    roots.push(current);
  });

  const sortByOrder = (arr) => {
    arr.sort((a, b) => {
      const ao = Number.isFinite(Number(a.order)) ? Number(a.order) : 0;
      const bo = Number.isFinite(Number(b.order)) ? Number(b.order) : 0;
      if (ao !== bo) return ao - bo;
      return (a.title || "").localeCompare(b.title || "");
    });
    arr.forEach((node) => sortByOrder(node.subsections));
  };

  sortByOrder(roots);
  return roots;
};

export const stripHtml = (html) => {
  if (!html) return "";
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};
